module.exports = __webpack_public_path__ + "static/media/1_pl.c1403d79.png";